import PropTypes from 'prop-types'

export const assignmentsShape = {
  strings: PropTypes.objectOf(PropTypes.string),
  required: PropTypes.arrayOf(PropTypes.object),
  optional: PropTypes.arrayOf(PropTypes.object),
  windowWidth: PropTypes.number,
}
